import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Field, Form as FinalForm } from 'react-final-form';
import { useHistory, useLocation } from 'react-router-dom';
import Form from '../../Form/Form';
import { H2 } from '../../Heading/Heading';
import FieldCheckbox from '../../FieldCheckbox/FieldCheckbox';
import { PrimaryButton } from '../../Button/Button';
import InquiryForm from '../InquiryForm/InquiryForm';
// Verification request form removed per request; import kept commented for easy restoration
// import VerificationForm from '../VerificationForm/VerificationForm';
import ContactFormOption from '../ContactFormOption/ContactFormOption';
import { ReactComponent as Envelope } from '../../../assets/icons/envelope.svg';
import { ReactComponent as PaperAirplane } from '../../../assets/icons/paper-airplane.svg';
import css from './ContactForm.module.css';
import { useSelector, useDispatch } from 'react-redux';
import { selectSubmitInProgress, submitContactForm } from '../../../ducks/contactForm.duck';

const ContactForm = ({ isLoggedIn }) => {
  const dispatch = useDispatch();
  const submitInProgress = useSelector(selectSubmitInProgress);
  const location = useLocation();
  const history = useHistory();
  const [submitted, setSubmitted] = useState(false);

  // Verification request type disabled (see below); always use generalInquiry,
  // even if a stale `?type=verification` link is visited directly.
  // const searchParams = new URLSearchParams(location.search);
  // const contactType =
  //   searchParams.get('type') === 'verification' ? 'verification' : 'generalInquiry';
  const contactType = 'generalInquiry';

  const setContactType = type => {
    if (type !== contactType) {
      const params = new URLSearchParams(location.search);
      params.set('type', type);
      history.replace({ search: `?${params.toString()}` });
    }
  };

  const requiredFields = {
    generalInquiry: ['firstName', 'lastName', 'email', 'phoneNumber', 'message'],
    verification: [
      'firstName',
      'lastName',
      'email',
      'phoneNumber',
      'dateOfBirth',
      'location',
      'address',
      'postalCode',
      'country',
      'message',
    ],
  };

  const validate = values => {
    const errors = {};
    (requiredFields[contactType] || []).forEach(field => {
      if (!values[field]) errors[field] = 'Dieses Feld ist erforderlich.';
    });
    return errors;
  };

  const onSubmit = async values => {
    const success = await dispatch(submitContactForm({ ...values, contactType }));
    if (success) {
      setSubmitted(true);
    }
  };

  if (submitted) {
    return (
      <div className={css.container}>
        <div className={css.thankYou}>
          <Envelope />
          <p className={css.thankYouText}>
            <FormattedMessage id="ContactForm.thankYou" />
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={css.container}>
      <FinalForm
        onSubmit={onSubmit}
        validate={validate}
        render={({ handleSubmit, submitFailed }) => (
          <Form onSubmit={handleSubmit} className={css.contactForm}>
            <H2 className={css.contactFormTitle}>
              <Envelope />
              <FormattedMessage id="ContactForm.title" />
            </H2>

            <div className={css.mainContent}>
              <div className={css.contactFormTypeContainer}>
                <ContactFormOption
                  type="generalInquiry"
                  setContactType={setContactType}
                  activeType={contactType}
                />
                {/* Verification request tab removed from contact page per request
                <ContactFormOption
                  type="verification"
                  setContactType={setContactType}
                  activeType={contactType}
                />
                */}
              </div>

              {/* Verification request form removed per request; always show the general inquiry form
              {contactType === 'generalInquiry' ? (
                <InquiryForm submitFailed={submitFailed} />
              ) : (
                <VerificationForm isLoggedIn={isLoggedIn} submitFailed={submitFailed} />
              )}
              */}
              <InquiryForm submitFailed={submitFailed} />

              {isLoggedIn && (
                <Field name="consent" type="checkbox">
                  {({ input, meta }) => (
                    <FieldCheckbox
                      {...input}
                      id="consent"
                      label={<FormattedMessage id="ContactForm.newsletter" />}
                      className={css.newsletter}
                      customErrorText={submitFailed && meta.error}
                    />
                  )}
                </Field>
              )}
            </div>

            {(isLoggedIn || contactType === 'generalInquiry') && (
              <PrimaryButton type="submit" className={css.sendButton} disabled={submitInProgress}>
                <FormattedMessage id="ContactForm.send" />
                <PaperAirplane className={css.sendSvg} />
              </PrimaryButton>
            )}
          </Form>
        )}
      />
    </div>
  );
};

export default ContactForm;
